<template>
  <div class="v2-page">
    <V2Circle />
    <div class="js-hero-wrap">
      <V2Hero />

      <V2Stripes />
    </div>

    <V2Skills />

    <V2Projects />

    <AppCursor />
  </div>
</template>

<script>
import V2Hero from "@/components/v2/V2Hero";
import V2Circle from "@/components/v2/V2Circle";
import V2Stripes from "@/components/v2/V2Stripes";
import V2Skills from "@/components/v2/V2Skills";
import V2Projects from "@/components/v2/V2Projects";
import AppCursor from "@/components/featureExamples/Cursor";

export default {
  name: "V2Home",
  components: {
    V2Hero,
    V2Circle,
    V2Stripes,
    V2Skills,
    V2Projects,
    AppCursor,
  },
};
</script>
